import axios from "@/axios"

const url = "/api/brain/tournament/ages/"

class TournamentAgesService {
	async getAges() {
		const { data } = await axios.get(`${url}`)
		return data
	}
	async saveAge(body) {
		const data = await axios.post(`${url}`, body)
		return data
	}
}
export default new TournamentAgesService()
